import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=c9b56c48&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b56c48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9b56c48')) {
      api.createRecord('c9b56c48', component.options)
    } else {
      api.reload('c9b56c48', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=c9b56c48&scoped=true&", function () {
      api.rerender('c9b56c48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2twYD7uYoT5DR/JS/comp/SearchFilterTokens.vue"
export default component.exports